import { Children } from 'react';

const emptyState = { blocks: [], entityMap: {} };
const shouldRenderChild = (expectedChildName, children) => {
  const child = Children.only(children);
  const childName = child == null ? void 0 : child.type.displayName;
  return !!children && childName === expectedChildName;
};

export { emptyState, shouldRenderChild };
//# sourceMappingURL=utils.js.map
